import { SetStateAction } from "react";

import { createAsyncThunk, Dispatch } from "@reduxjs/toolkit";
import axios from "axios";

import { defaultRecipeTableData } from "../../components/recipeCreation/createRecipeUtils";
import rejectedWithValueErrorHandler from "../../components/recipeCreation/utils/RejectedWithValueErrorHandler";
import { cloudinaryFetch } from "../../services/restApiServices/cloudinaryUpload.services";
import { DEFAULT_RECIPE_CREATION_IMAGE_LINK, IMAGE_GENERATION_API, RECIPE_CREATION_TIMEOUT } from "../constants/constants";
import { setInitialRecipeOpen } from "./createRecipe.slice";

export const recipeCreation = createAsyncThunk<{ userId: string | null, deviceId: string | null, recipeId: string }, { recipeName: string, insertRecipes: any, servingSize: number, userId: string | null, deviceId: string | null, history: any, dispatch: Dispatch }, { rejectValue: { message: string, userId: string | null, deviceId: string | null } }>('recipeCreation/recipeCreation', async ({ recipeName, insertRecipes, servingSize, userId, deviceId, history, dispatch }, { rejectWithValue }) => {
  if (!userId) {
    return rejectWithValue(rejectedWithValueErrorHandler(userId, deviceId, 'No user Id'))
  }

  const imageResult: any = await axios({
    method: 'post', url: IMAGE_GENERATION_API, timeout: RECIPE_CREATION_TIMEOUT, data: { imageTitle: recipeName, imageType: "recipe" },
  }).catch((error: Error) => rejectWithValue(rejectedWithValueErrorHandler(userId, deviceId, JSON.stringify(error))))

  const { recipeObject, recipeVariatonObject, stepObject, recipeVariationStep, stepSubStepsArray } = defaultRecipeTableData(recipeName, imageResult?.data ?? DEFAULT_RECIPE_CREATION_IMAGE_LINK, servingSize, userId)
  const recipeData = {
    ...recipeObject,
    Recipe_Variations: [{
      ...recipeVariatonObject,
      RecipeVariations_Steps: [{
        ...recipeVariationStep,
        StepsE3: {
          ...stepObject,
          Steps_Substeps: [...stepSubStepsArray]
        }
      }]
    }]
  }

  const insertRecipeResult = await insertRecipes({
    variables: { recipeData, userId, recipe_Id: recipeData.id }
  }).catch((error: Error) => rejectWithValue(rejectedWithValueErrorHandler(userId, deviceId, JSON.stringify(error))))

  const recipeId = insertRecipeResult?.data?.insert_User_Generated_Recipes_one?.recipeData?.id
  dispatch(setInitialRecipeOpen(true))
  history.push(`/userCreatedRecipe/${recipeId}`);
  return { userId, deviceId, recipeId: recipeData.id };
})

export const cloudinaryUpload = createAsyncThunk('recipeCreation/imageCloudinaryUpload', async ({ imageFile, setImage, setLoader }: { imageFile: File, setImage: React.Dispatch<SetStateAction<string>>, setLoader: React.Dispatch<SetStateAction<boolean>> }) => {
  try {
    if (!imageFile) {
      return;
    }

    const response = await cloudinaryFetch({ imageFile });

    if (response.ok) {
      const data = await response.json();
      setImage(data?.secure_url)
      setLoader(false)
    } else {
      console.error("Error uploading image:", response.statusText);
      setLoader(false)
    }
  } catch (error) {
    console.error("Error uploading image:", error);
    setLoader(false)
  }
})